import React, { Fragment } from 'react';
import { XCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const painPoints = [<Fragment data-id="element-244">
      Arrancás motivado, pero después de unos días{' '}
      <strong data-id="element-245">volvés a desordenarte.</strong>
    </Fragment>, <Fragment data-id="element-246">
      <strong data-id="element-247">No sabés qué comer</strong>, cuánto comer ni cómo organizar tus
      comidas.
    </Fragment>, <Fragment data-id="element-248">
      Comés "más o menos sano", pero <strong data-id="element-249">la panza sigue igual.</strong>
    </Fragment>, <Fragment data-id="element-250">
      Sentís que el fin de semana <strong data-id="element-251">te arruina todo el esfuerzo.</strong>
    </Fragment>, <Fragment data-id="element-252">
      Bajás unos kilos, pero <strong data-id="element-253">después los recuperás.</strong>
    </Fragment>, <Fragment data-id="element-254">
      Te cansaste de dietas que te dejan con{' '}
      <strong data-id="element-255">hambre, ansiedad y mal humor.</strong>
    </Fragment>, <Fragment data-id="element-256">
      Tenés miedo de bajar de peso y quedar{' '}
      <strong data-id="element-257">flaco, blando o sin forma.</strong>
    </Fragment>, <Fragment data-id="element-258">
      Te mirás al espejo y sentís que{' '}
      <strong data-id="element-259">podrías estar mucho mejor.</strong>
    </Fragment>];
  return <section className="py-14 md:py-20 bg-black pt-[10px] pb-[10px] space-y-[16px]" data-id="element-260">
      <div className="container mx-auto px-5 sm:px-6 md:px-8 mt-[10px] mb-[10px]" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-262">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white md:mb-24 text-center uppercase tracking-tight leading-[0.95] pt-[10px] pb-[10px] mt-[0px] mb-[0px]" data-id="element-263">
            Probablemente <span className="text-red-500" data-id="element-264">te pasa que…</span>
          </h2>

          <div className="space-y-4 md:space-y-6" data-id="element-265">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.05 * index
          }} className="flex gap-5 bg-red-950/20 border border-red-900/30 p-6 md:p-8 rounded-2xl pt-[24px] pb-[24px] flex-row items-center justify-start" data-id="element-266">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-267" />
                <p className="text-zinc-200 text-lg md:text-xl leading-relaxed" data-id="element-268">
                  {point}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}